import React from "react";
import m from "../../images/dusan.jpg";
import ch from "../../images/chat.svg";
import sq from "../../images/square.svg";
import app from "../../images/apple.svg";
import fb from "../../images/facebook.svg";
import ar from "../../images/airbnb.svg";
import gg from "../../images/google.svg";
import am from "../../images/amazon.svg";
import o from "../../images/re.jpeg";
import o1 from "../../images/ree.jpeg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Review() {
  const navigate = useNavigate()
  return (
    <div>
       <div>
      <div class="wrapper">
        <div class="re">
          <div class="re1">
            <div class=" re2 cards">
              <div class="re3">
                <div class="wrapper">
                  <img src={o1} alt="avatar" class=" re4" />
                </div>
                <p class=" re5">nabeel perfumes</p>
                <p class="re6">Dubai</p>
                <p class="re7">
                I am delighted to share my experience with Aara Clouds as a customer. Their services have truly exceeded my expectations and have been instrumental in the success of my online presence.
                This has significantly improved the overall user experience and has helped me attract and retain more visitors to my site.
                </p>
              </div>
              <div class="re3">
                <div class="wrapper">
                  <img src={o} alt="avatar" class=" re4" />
                </div>
                <p class=" re5">Per Larsson</p>
                <p className="text-blue-800 font-bold">sampletekk.com</p>
                <p class="re6"></p>
                <p class="re7">
                When I first started my website, I was looking for a reliable hosting provider that could ensure my website's performance and availability. Aara Clouds has delivered on both fronts and more. The uptime of my website has been outstanding, with minimal downtime or disruptions. This has given me peace of mind, knowing that my website is accessible to visitors around the clock.
                </p>
              </div>
            </div>
            <div class=" re8 text">
              <p className="re9 font-bold">Trusted By Teams</p>
            
              <p class="re11">
              Aara clouds team deploy on-demand open-source cost-effective firewall for inhouse customer IT infrastructures. The team is available 24*7 for support in terms of maintenance. Book an appointment with a sales representative now.
              </p>
              <span class=" re12" href="/stories">
                <button class=" b1" onClick={() =>{localStorage.getItem("token")?(navigate("/profile")):toast("! Please login ")}}>
              
                  <img src={ch} alt="More stories" class="b2 icon" />
                  <p class=" b3">More stories</p>
                </button>
              </span>
            </div>
          </div>

          <div class=" lo logos">
            <div class="wrapper">
              <img src={"	https://static-00.iconduck.com/assets.00/aws-icon-2048x2048-ptyrjxdo.png"} alt="company logo" class=" im" />
            </div>
            <div class="wrapper">
              <img src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJTd9m0Ux-JPLHMZQPteE6-d7tUnZC86YE5PyPeu6V&s"} alt="company logo" class=" im" />
            </div>
            <div class="wrapper">
              <img src={"	https://static-00.iconduck.com/assets.00/microsoft-azure-icon-512x314-aslik1g6.png"} alt="company logo" class="im" />
            </div>
            <div class="wrapper">
              <img src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbxUVQA2MWL2fX7BvqFj2fulV0Mu8i5VfqwNNhz32e1w&s"} alt="company logo" class="im" />
            </div>
            <div class="wrapper">
              <img src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxGql-ppSu2ND3mSNav44kKuGS3y_7_aley5DUib4&s"} alt="company logo" class="im" />
            </div>
            <div class="wrapper">
              <img src={"	https://cdn-icons-png.flaticon.com/512/4494/4494740.png"} alt="company logo" class="im" />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
